import Login from '@/api/pub';
import { $getLocalStorage } from '@/assets/common/common';
import { useLang } from '@/hooks/lang';
const { $t } = useLang( '@shining3d/app' );

export function useGetFactoryList({ store, isSetFactory, factoryID, reload = true }) {
	let _factoryID = '';
	if ( !factoryID ) {
		_factoryID = $getLocalStorage( 'currentOrganization' )?.id || '';
	} else {
		_factoryID = factoryID;
	}
	return Login.getFactoryBriefList({ origin: 'sdkCloud' }).then(( _res ) => {
		if ( _res.status === 'success' ) {
			let factoryList;
			if ( _res.result && Array.isArray( _res.result )) {
				factoryList = [..._res.result, { id: 'new', name: $t( 'useGetFactoryList.createFactory' ), factoryType: 'new', type: 'new' }];
				if ( !isSetFactory ) {
					store.commit( 'setFactorySelect', factoryList[ 0 ]);
				} else {
					const activeList = factoryList.find(( v ) => v.id === _factoryID );
					store.commit( 'setFactorySelect', activeList );
				}
			} else {
				factoryList = [{ id: 'new', name: $t( 'useGetFactoryList.createFactory' ), factoryType: 'new', type: 'new' }];
			}
			factoryList.forEach(( item ) => {
				item.lastState = item.id === _factoryID ? 'y' : 'n';
			});
			store.commit( 'setFactoryObjs', factoryList );
			if ( reload ) {
				window.location.reload();
			}
		}
	});
}
